/* Mobile behavior override for the theme's existing product-sticky-form. */
(() => {
  const getNumber = (element, attribute, fallback) => {
    const rawValue = element?.getAttribute(attribute);
    if (rawValue === null || rawValue === undefined || rawValue === '') return fallback;

    const value = Number(rawValue);
    return Number.isFinite(value) ? value : fallback;
  };

  const initStickyForm = () => {
    const stickyForm = document.querySelector('product-sticky-form');
    if (!stickyForm || stickyForm.dataset.bjMobileInitialized === 'true') return;

    const card = stickyForm.querySelector('.product-sticky-form__card');
    const variantRow = stickyForm.querySelector('.product-sticky-form__variant');
    const submitButton = variantRow?.querySelector('button[type="submit"]');
    const formId = stickyForm.getAttribute('form');
    const productForm = formId ? document.getElementById(formId) : null;

    if (!card || !variantRow || !submitButton || !productForm) return;

    stickyForm.dataset.bjMobileInitialized = 'true';
    card.classList.add('bj-sticky-ready');

    const themeCartIcon = submitButton.querySelector('.btn-text .icon');
    if (themeCartIcon) {
      themeCartIcon.outerHTML = `
        <svg class="bj-sticky-cart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M8 22C8.55228 22 9 21.5523 9 21C9 20.4477 8.55228 20 8 20C7.44772 20 7 20.4477 7 21C7 21.5523 7.44772 22 8 22Z" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M19 22C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20C18.4477 20 18 20.4477 18 21C18 21.5523 18.4477 22 19 22Z" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.0498 2.05005H4.0498L6.7098 14.47C6.80738 14.9249 7.06048 15.3315 7.42552 15.6199C7.79056 15.9083 8.24471 16.0604 8.7098 16.05H18.4898C18.945 16.0493 19.3863 15.8933 19.7408 15.6079C20.0954 15.3224 20.3419 14.9246 20.4398 14.48L22.0898 7.05005H5.1198" stroke="#F2F2F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
    }

    const quantityControl = document.createElement('div');
    quantityControl.className = 'bj-sticky-quantity';
    quantityControl.setAttribute('aria-label', 'Quantity');
    quantityControl.innerHTML = `
      <button type="button" data-quantity-action="minus" aria-label="Decrease quantity">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M4.1665 10H15.8332" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <input type="number" inputmode="numeric" aria-label="Quantity" value="1">
      <button type="button" data-quantity-action="plus" aria-label="Increase quantity">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M4.16699 10H15.8337" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10 4.16675V15.8334" stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>`;
    variantRow.insertBefore(quantityControl, submitButton);

    const stickyQuantity = quantityControl.querySelector('input');
    const getSourceQuantity = () => {
      const escapedFormId = window.CSS?.escape ? CSS.escape(formId) : formId;
      return document.querySelector(`input[name="quantity"][form="${escapedFormId}"]`)
        || productForm.querySelector('input[name="quantity"]');
    };

    const syncFromSource = () => {
      const source = getSourceQuantity();
      const min = getNumber(source, 'min', 1);
      const step = getNumber(source, 'step', 1);
      const max = getNumber(source, 'max', Infinity);
      const value = Number(source?.value);

      stickyQuantity.min = String(min);
      stickyQuantity.step = String(step);
      stickyQuantity.removeAttribute('max');
      if (Number.isFinite(max)) stickyQuantity.max = String(max);
      stickyQuantity.value = String(Number.isFinite(value) ? value : min);
    };

    const syncToSource = () => {
      const source = getSourceQuantity();
      if (!source) return;

      source.value = stickyQuantity.value;
      source.dispatchEvent(new Event('change', { bubbles: true }));
    };

    quantityControl.addEventListener('click', (event) => {
      const actionButton = event.target.closest('[data-quantity-action]');
      if (!actionButton) return;

      const min = getNumber(stickyQuantity, 'min', 1);
      const step = getNumber(stickyQuantity, 'step', 1);
      const max = getNumber(stickyQuantity, 'max', Infinity);
      const direction = actionButton.dataset.quantityAction === 'plus' ? 1 : -1;
      const current = Number(stickyQuantity.value) || min;

      stickyQuantity.value = String(Math.min(max, Math.max(min, current + (step * direction))));
      syncToSource();
    });

    stickyQuantity.addEventListener('change', () => {
      const min = getNumber(stickyQuantity, 'min', 1);
      const max = getNumber(stickyQuantity, 'max', Infinity);
      stickyQuantity.value = String(Math.min(max, Math.max(min, Number(stickyQuantity.value) || min)));
      syncToSource();
    });

    document.addEventListener('change', (event) => {
      if (event.target === getSourceQuantity()) syncFromSource();
    });
    productForm.addEventListener('variant:change', () => window.requestAnimationFrame(syncFromSource));

    syncFromSource();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyForm, { once: true });
  } else {
    initStickyForm();
  }
})();

// Custom pricing

(function () {
  'use strict';

  if (window.__bjBundlePricingObserver) return;

  const widgetSelector = '.bx-widget-container';
  const emptySelector = '.js-bx-bundle-slot .bx-bundle-empty';

  function parseMoney(text) {
    let value = (text || '').replace(/[^\d.,-]/g, '');
    if (!value) return NaN;

    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');

    if (comma > dot) {
      value = value.replace(/\./g, '').replace(',', '.');
    } else {
      value = value.replace(/,/g, '');
    }

    return Number(value);
  }

  function getOfferPrice(widget, key) {
    const offer = widget.querySelector(
      `.bx-offer-wrap[data-offer-key="${key}"]`
    );

    const price = offer?.querySelector(
      '.bx-offer-prices .bx-discounted-price'
    );

    return parseMoney(price?.textContent);
  }

  function formatMoney(amount) {
    const currency = window.Shopify?.currency?.active;
    if (!currency) return null;

    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency: currency
        }
      ).format(amount);
    } catch (error) {
      return null;
    }
  }

  function updateWidget(widget) {
    const basePrice = getOfferPrice(widget, '0');
    const onePadTotal = getOfferPrice(widget, '1');

    const padPrice = onePadTotal - basePrice;

    const validPrices =
      Number.isFinite(basePrice) &&
      Number.isFinite(padPrice) &&
      padPrice > 0;

    [
      { key: '2', quantity: 2, discount: 0.10 },
      { key: '3', quantity: 3, discount: 0.15 }
    ].forEach(config => {
      const offer = widget.querySelector(
        `.bx-offer-wrap[data-offer-key="${config.key}"]`
      );

      if (!offer) return;

      // const hasEmpty = !!offer.querySelector(emptySelector); real price only effect when all slots are full. 

      // Works even 1 slot is filled
      const slots = offer.querySelectorAll('.js-bx-bundle-slot');

      const emptySlots = offer.querySelectorAll(
        '.js-bx-bundle-slot .bx-bundle-empty'
      );
      // Works even 1 slot is filled - end

      const hasEmpty =
        slots.length > 0 &&
        emptySlots.length === slots.length;

      

      offer.classList.toggle(
        'bj-has-empty-slots',
        hasEmpty
      );

      if (!hasEmpty || !validPrices) {
        offer.removeAttribute('data-bj-preview-price');
        return;
      }

      const total =
        basePrice +
        (padPrice * config.quantity * (1 - config.discount));

      const formatted = formatMoney(total);

      const priceElement = offer.querySelector(
        '.bx-offer-prices .bx-discounted-price'
      );

      if (formatted && priceElement) {
        if (priceElement.dataset.bjPreviewPrice !== formatted) {
          priceElement.dataset.bjPreviewPrice = formatted;
        }
      } else {
        priceElement?.removeAttribute('data-bj-preview-price');
      }
    });
  }

  let scheduled = false;

  function updateAll() {
    document.querySelectorAll(widgetSelector)
      .forEach(updateWidget);
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      updateAll();
    });
  }

  function initialize() {
    if (window.__bjBundlePricingObserver) return;

    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    window.__bjBundlePricingObserver = observer;

    scheduleUpdate();

    console.log('[BlinkJoy] Bundle pricing preview initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once: true
    });
  } else {
    initialize();
  }
})();
